import Tooltip from '@components/Tooltip';
import type { FC, ReactElement } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

import './Section.scss';

type SectionProps = {
  title: string;
  style?: {
    [key: string]: any;
  };
  'data-tour'?: string;
  children?: ReactElement | ReactElement[];
  tooltip?: string;
};

const Section: FC<SectionProps> = ({
  title,
  style,
  children,
  tooltip,
  'data-tour': dataTour,
}) => {
  return (
    <div className="section" style={style} data-tour={dataTour}>
      <div className="section__title">
        <span>{title}</span>
        {tooltip && (
          <Tooltip content={tooltip}>
            <FaInfoCircle />
          </Tooltip>
        )}
      </div>
      <div className="section__content">{children}</div>
    </div>
  );
};

export default Section;
